// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__3BCmU","line":"style_line__3R_g7","fontSize1":"style_fontSize1__1sw-N","bold":"style_bold__2Mi6D"};